import React from "react";
import { Navigate, Route } from "react-router-dom";
import {
  BookerBookingsPage,
  BookerCouponsPage,
  BookerDashboardPage,
  BookerLoginPage,
  BookerPortalLayout,
  BookerProfilePage,
  BookerRewardsHistoryPage,
} from "@/pages/booker/BookerPortal.jsx";

const BookerRoutes = () => (
  <>
    <Route path="/booker/login" element={<BookerLoginPage />} />
    <Route path="/booker" element={<BookerPortalLayout />}>
      <Route index element={<Navigate to="/booker/dashboard" replace />} />
      <Route path="dashboard" element={<BookerDashboardPage />} />
      <Route path="bookings" element={<BookerBookingsPage />} />
      <Route path="rewards" element={<BookerRewardsHistoryPage />} />
      <Route path="coupons" element={<BookerCouponsPage />} />
      <Route path="profile" element={<BookerProfilePage />} />
    </Route>
  </>
);

export default BookerRoutes;
